export const COOKIE_NAMES = {
    LANGUAGE_SELECTION_AKA: 'languageSelection_jar_aka',
    LOCALE_AKA: 'localeCookie_jar_aka'
};
